import React, { useState } from "react";
import "./FAQ.css";

const leftColumn = [
  {
    question: "Why should I choose Glamur Paint over other brands?",
    answer:
      "Glamur Paint offers exceptional coverage, long-lasting colors, and a flawless finish using advanced, eco-friendly technology ensuring your walls look elegant and stay protected for years.",
  },
  {
    question: "What makes Glamur Paint’s finish unique?",
    answer:
      "Our paints are formulated with premium pigments and smooth-flow technology, delivering a luxurious texture and even application that enhances any interior or exterior space.",
  },
];

const rightColumn = [
  {
    question: "Does Glamur Paint provide value for money?",
    answer:
      "Absolutely. Glamur Paint combines affordable pricing with premium-grade quality, giving you professional results without compromise — making it a smart and lasting investment.",
  },
  {
    question: "How durable is Glamur Paint?",
    answer:
      "Glamur Paint is built to withstand time, weather, and wear. Its advanced formulation resists fading, peeling, and stains, keeping your walls vibrant and protected in all conditions.",
  },
  {
    question: "Is Glamur Paint suitable for all types of spaces?",
    answer:
      "Yes. Whether it’s a modern home, commercial space, or exterior surface, Glamur Paint offers a wide range of finishes and shades designed to match every style and need.",
  },
];

const FAQwhy = () => {
  // ✅ Default open the first question (L0)
  const [activeIndex, setActiveIndex] = useState("L0");

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderFAQItem = (item, index, columnPrefix) => (
    <div
      key={columnPrefix + index}
      className={`faq-item ${
        activeIndex === columnPrefix + index ? "active" : ""
      }`}
      onClick={() => toggleFAQ(columnPrefix + index)}
    >
      <div className="faq-question">
        <span className="faq-icon">
          {activeIndex === columnPrefix + index ? "–" : "+"}
        </span>
        <h3>{item.question}</h3>
      </div>
      {activeIndex === columnPrefix + index && item.answer && (
        <p className="faq-answer">{item.answer}</p>
      )}
    </div>
  );

  return (
    <section className="faq-section">
      <h2 className="faq-title">Why Choose Glamur Paint – FAQs</h2>
      <div className="faq-columns">
        <div className="faq-column">
          {leftColumn.map((item, i) => renderFAQItem(item, i, "L"))}
        </div>
        <div className="faq-column">
          {rightColumn.map((item, i) => renderFAQItem(item, i, "R"))}
        </div>
      </div>
    </section>
  );
};

export default FAQwhy;
